import {
  bcbfCourseIds,
  draCourseIds,
  onboardingPortalBaseURL,
  onboardingPortalBaseURLBCBF,
} from "../config";

export const getCourseIds = () => {
  const hostname = window?.location?.hostname;
  console.log(hostname, onboardingPortalBaseURL, onboardingPortalBaseURLBCBF);
  console.log(draCourseIds, bcbfCourseIds);

  if (hostname.includes(onboardingPortalBaseURL)) {
    return draCourseIds;
  }
  if (hostname.includes(onboardingPortalBaseURLBCBF)) {
    return bcbfCourseIds;
  }
  return [];
};
